import * as types from '../../types/dashboardIndex';

export const setClickedPageIndex = data  => {
  return {
      type: types.SET_ACTIVE_PAGE,
      payload: data
    };
}
